export const blogData = [
    {
        id: 1,
        title: 'Cloning Sportsjam.in',
        description: 'My expeirence working on my first big project within the Masai Curriculum',
        date: 'Dec 19, 2021',
        image: 'https://miro.medium.com/max/875/1*R__cdn8L1gYGK1Tdqqyubg.png',
        url: 'https://medium.com/@sreerag.rajan5/cloning-sportsjam-in-cd1c80c1b06b'
    },
    {
        id: 2,
        title: 'CLONING RELIANCE DIGITAL',
        description: 'Experience of the second project.',
        date: 'Jan 23, 2022',
        image: 'https://miro.medium.com/max/875/1*nY9cUfzwtDaM6lGyvj4STg.png',
        url: 'https://medium.com/@sreerag.rajan5/cloning-reliance-digital-439cd56d46a3'
    },
    {
        id: 3,
        title: 'Reliance Digital Clone (Part II)',
        description: 'The experience of the third project, with a focus on leadership skills',
        date: 'Feb 27, 2022',
        image: 'https://miro.medium.com/max/875/1*qRNfRbuHCDC1ct0chLZoWA.png',
        url: 'https://medium.com/@sreerag.rajan5/reliance-digital-clone-part-ii-57797eaf1ddf'
    },
    
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/